import { render, staticRenderFns } from "./StocksConfiguration.vue?vue&type=template&id=757b50a3&scoped=true&"
import script from "./StocksConfiguration.vue?vue&type=script&lang=js&"
export * from "./StocksConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./StocksConfiguration.vue?vue&type=style&index=0&id=757b50a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757b50a3",
  null
  
)

export default component.exports